import { Add } from '@mui/icons-material';
import { SupportFilters, SupportTicketCardSkeleton } from '@practium/features/support';
import { Button, EmptyState, Pagination } from '@practium/ui';
import { SupportTicketCard } from '../components/SupportTicketCard/SupportTicketCard';
import { TicketModal } from '../components/TicketModal/TicketModal';
import { useSupportPage } from '../hooks/useSupportPage';
import { CLIENT_STATUS_OPTIONS } from '../constants/filterOptions';
import styles from './SupportPage.module.css';

interface SupportPageProps {
	userName: string;
	avatarUrl?: string;
}

export const SupportPage = ({ userName, avatarUrl }: SupportPageProps) => {
	const {
		tickets,
		totalDocs,
		totalPages,
		page,
		setPage,
		isLoading,
		period,
		handlePeriodChange,
		statusFilter,
		handleStatusChange,
		sortOrder,
		handleSortChange,
		customDateFrom,
		customDateTo,
		handleDateRangeChange,
		isCreateModalOpen,
		setIsCreateModalOpen,
		handleCreate,
		replyingTicket,
		setReplyingTicket,
		handleReply,
		isSubmitting,
	} = useSupportPage();

	return (
		<div className={styles.page}>
			<div className={styles.contentWrapper}>
				<div className={styles.header}>
					<div className={styles.headerLeft}>
						<h1 className={styles.title}>Solicitações de Suporte</h1>
						<p className={styles.subtitle}>Veja seu histórico ou gere uma nova solicitação</p>
					</div>
					<Button
						variant="primary"
						onClick={() => setIsCreateModalOpen(true)}
						className={styles.actionBtn}
						icon={<Add style={{ fontSize: '1.1rem' }} />}
					>
						Nova Solicitação
					</Button>
				</div>

				<div className={styles.card}>
					<SupportFilters
						period={period}
						onPeriodChange={handlePeriodChange}
						statusFilter={statusFilter}
						onStatusChange={handleStatusChange}
						statusOptions={CLIENT_STATUS_OPTIONS}
						sortOrder={sortOrder}
						onSortChange={handleSortChange}
						totalCount={totalDocs}
						customDateFrom={customDateFrom}
						customDateTo={customDateTo}
						onDateRangeChange={handleDateRangeChange}
					/>

					<div className={styles.content}>
						{isLoading ? (
							<div className={styles.list}>
								{(['sk-a', 'sk-b', 'sk-c', 'sk-d', 'sk-e', 'sk-f'] as const).map((k) => (
									<SupportTicketCardSkeleton key={k} />
								))}
							</div>
						) : tickets.length === 0 ? (
							<EmptyState
								title="Nenhuma solicitação encontrada"
								description="Abra uma nova solicitação clicando em '+ Nova Solicitação'."
							/>
						) : (
							<div className={styles.list}>
								{tickets.map((ticket) => (
									<SupportTicketCard
										key={ticket._id}
										ticket={ticket}
										userName={userName}
										avatarUrl={avatarUrl}
										onReply={setReplyingTicket}
									/>
								))}
							</div>
						)}
					</div>

					<Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
				</div>

				<TicketModal
					mode="create"
					isOpen={isCreateModalOpen}
					onClose={() => setIsCreateModalOpen(false)}
					onSubmit={handleCreate}
					isLoading={isSubmitting}
				/>

				<TicketModal
					mode="reply"
					ticket={replyingTicket}
					isOpen={!!replyingTicket}
					onClose={() => setReplyingTicket(null)}
					onSubmit={handleReply}
					isLoading={isSubmitting}
				/>
			</div>
		</div>
	);
};
